import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, watch } from 'vue';
import { useRoomStore } from '../../stores/room';
import { storeToRefs } from 'pinia';
import TuiSelect from './base/Select';
import TuiOption from './base/Option';

import {
  TRTCDeviceInfo,
  TUIDeviceInfo,
  TUIMediaDeviceType,
} from '@tencentcloud/tuiroom-engine-js';
import useDeviceManager from '../../hooks/useDeviceManager';
interface Props {
  deviceType: string;
  onChange?: (id: string) => void;
  disabled?: boolean;
}
// eslint-disable-next-line vue/no-setup-props-destructure

export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceSelect',
  props: {
    deviceType: null,
    onChange: null,
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const { deviceType, onChange, disabled = false } = __props as {
  deviceType: string;
  onChange?: (id: string) => void;
  disabled?: boolean;
};

const { deviceManager } = useDeviceManager();



const roomStore = useRoomStore();
const {
  cameraList,
  microphoneList,
  speakerList,
  currentCameraId,
  currentMicrophoneId,
  currentSpeakerId,
} = storeToRefs(roomStore);

const deviceList: Ref<TRTCDeviceInfo[]> = ref(getDeviceList());
const currentDeviceId = ref(getInitDeviceId());

function getInitDeviceId() {
  if (deviceType === 'camera') {
    return currentCameraId.value;
  }
  if (deviceType === 'microphone') {
    return currentMicrophoneId.value;
  }
  if (deviceType === 'speaker') {
    return currentSpeakerId.value;
  }
  return '';
}

if (deviceType === 'camera') {
  watch(
    currentCameraId,
    val => {
      if (currentDeviceId.value !== val) {
        currentDeviceId.value = val;
      }
    },
    { immediate: true }
  );
}

if (deviceType === 'microphone') {
  watch(
    currentMicrophoneId,
    val => {
      if (currentDeviceId.value !== val) {
        currentDeviceId.value = val;
      }
    },
    { immediate: true }
  );
}

if (deviceType === 'speaker') {
  watch(
    currentSpeakerId,
    val => {
      if (currentDeviceId.value !== val) {
        currentDeviceId.value = val;
      }
    },
    { immediate: true }
  );
}

function getDeviceList() {
  if (deviceType === 'camera') {
    return cameraList;
  }
  if (deviceType === 'microphone') {
    return microphoneList;
  }
  if (deviceType === 'speaker') {
    return speakerList;
  }
  return [];
}

async function handleChange(deviceId: string) {
  onChange && onChange(deviceId);
  switch (deviceType) {
    case 'camera':
      try {
        await deviceManager.instance?.setCurrentDevice({
          type: TUIMediaDeviceType.kMediaDeviceTypeVideoCamera,
          deviceId,
        });
        roomStore.setCurrentCameraId(deviceId);
      } catch (error) {
        if (
          cameraList.value
            .map((item: TUIDeviceInfo) => item.deviceId)
            .includes(currentCameraId.value)
        ) {
          currentDeviceId.value = currentCameraId.value;
        }
      }
      break;
    case 'microphone':
      try {
        await deviceManager.instance?.setCurrentDevice({
          type: TUIMediaDeviceType.kMediaDeviceTypeAudioInput,
          deviceId,
        });
        roomStore.setCurrentMicrophoneId(deviceId);
      } catch (error) {
        if (
          microphoneList.value
            .map((item: TUIDeviceInfo) => item.deviceId)
            .includes(currentMicrophoneId.value)
        ) {
          currentDeviceId.value = currentMicrophoneId.value;
        }
      }
      break;
    case 'speaker':
      try {
        await deviceManager.instance?.setCurrentDevice({
          type: TUIMediaDeviceType.kMediaDeviceTypeAudioOutput,
          deviceId,
        });
        roomStore.setCurrentSpeakerId(deviceId);
      } catch (error) {
        if (
          speakerList.value
            .map((item: TUIDeviceInfo) => item.deviceId)
            .includes(currentSpeakerId.value)
        ) {
          currentDeviceId.value = currentSpeakerId.value;
        }
      }
      break;
    default:
      break;
  }
}

return { __sfc: true,deviceManager, roomStore, cameraList, microphoneList, speakerList, currentCameraId, currentMicrophoneId, currentSpeakerId, deviceList, currentDeviceId, getInitDeviceId, getDeviceList, handleChange, TuiSelect, TuiOption }
}

})